export var DataCatalogColumnType;
(function (DataCatalogColumnType) {
    DataCatalogColumnType["DATA_CATALOG_COLUMN_TYPE_STRING"] = "STRING";
    DataCatalogColumnType["DATA_CATALOG_COLUMN_TYPE_INTEGER"] = "INTEGER";
    DataCatalogColumnType["DATA_CATALOG_COLUMN_TYPE_DOUBLE"] = "DOUBLE";
    DataCatalogColumnType["DATA_CATALOG_COLUMN_TYPE_DECIMAL"] = "DECIMAL";
    DataCatalogColumnType["DATA_CATALOG_COLUMN_TYPE_BOOLEAN"] = "BOOLEAN";
    DataCatalogColumnType["DATA_CATALOG_COLUMN_TYPE_DATE"] = "DATE";
    DataCatalogColumnType["DATA_CATALOG_COLUMN_TYPE_TIMESTAMP"] = "TIMESTAMP";
})(DataCatalogColumnType || (DataCatalogColumnType = {}));
